// @file List of provide/inject keys used in Whiteboard.
// @see https://vuejs.org/guide/components/provide-inject.html#working-with-symbol-keys
// @see https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
import type { InjectionKey } from 'vue'

export const whiteboardAudioPlayerV2Key = Symbol('whiteboardAudioPlayerV2') as InjectionKey<boolean>
